import { createSlice } from '@reduxjs/toolkit'

import { Material } from './materialsApi.types'
import { Payload, ReduxRootState } from '../../../../types'

interface State {
  materials: Material[]
}

const initialState: State = {
  materials: [],
}

const currentMaterialsSlice = createSlice({
  name: 'currentMaterials',
  initialState,
  reducers: {
    setMaterials: (state, { payload }: Payload<Material[]>) => {
      state.materials = payload
    },
    removeMaterial: (state, { payload }: Payload<string>) => {
      state.materials = state.materials.filter((m) => m.id !== payload)
    },
    renameMaterial: (
      state,
      { payload }: Payload<{ id: string; newName: string }>
    ) => {
      const toRename = state.materials.find((m) => m.id === payload.id)
      if (!toRename) return
      toRename.name = payload.newName
    },
    resetMaterials: (state) => {
      state.materials = []
    },
  },
})

export const { setMaterials, removeMaterial, renameMaterial } =
  currentMaterialsSlice.actions

export const currentMaterialsReducer = currentMaterialsSlice.reducer

export const currentMaterialsSelector = {
  selectCurrentMaterials: (state: ReduxRootState) =>
    state.currentMaterials.materials,
}
